import { IVeiculoDto } from '../../../../global/dataTransferObjects/veiculo';
import { IDebitosDto } from '../../../../global/dataTransferObjects/debitosVeiculares';
import { IPagedResult } from '../../../../global/generics';

export interface IPageState {
  loading: boolean;
  isPaymentModalOpen: boolean;
  valorTotal: number;
  valorLiquido: number;
  vehicleId: string;
  veiculos: IPagedResult<IVeiculoDto>;
  debits: IDebitosDto;
  selectedDebitos: IDebitosDto;
}

export enum ActionTypes {
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  UPDATE_VEICULOS = 'UPDATE_VEICULOS',
  UPDATE_DEBITS_VEHICLES = 'UPDATE_DEBITS_VEHICLES',
  UPDATE_PAYMENT_MODAL_STATUS = 'UPDATE_PAYMENT_MODAL_STATUS',
  OPEN_PAYMENT_MODAL = 'OPEN_PAYMENT_MODAL',
  UPDATE_LICENCIAMENTO_SELECTION = 'UPDATE_LICENCIAMENTO_SELECTION',
  UPDATE_MULTAS_SELECTION = 'UPDATE_MULTAS_SELECTION',
  UPDATE_DPVATS_SELECTION = 'UPDATE_DPVATS_SELECTION',
  UPDATE_IPVAS_SELECTION = 'UPDATE_IPVAS_SELECTION',
  UPDATE_TOTAL = 'UPDATE_TOTAL',
  CLOSE_PAYMENT_MODAL = 'CLOSE_PAYMENT_MODAL',
}

export interface IAction {
  type: ActionTypes;
  payload?: any,
}
